module.exports = __webpack_public_path__ + "img/background2.4f04ed53.png";